module.exports = __webpack_public_path__ + "img/ZB53详情页_14.f8437a18.jpg";